const getKebabFromString = (str?: string): string =>
  str
    ? str
        .replace(/[^\w\s]/gi, '')
        .toLowerCase()
        .split(' ')
        .join('-')
    : '';

export default getKebabFromString;
